<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <Header />
    <router-view/>
    <LoginDialog ref="loginDialog" />
    <Footer />
    <!-- ✅ 全局浮窗 -->
    <FloatingBar />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import LoginDialog from './components/LoginDialog.vue';
import FloatingBar from './components/FloatingBar.vue'
// import { mapState, mapMutations } from 'vuex';
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    LoginDialog,
    FloatingBar
  },
  created() {
    const token = localStorage.getItem('token')
    if (token) {
      // 静默恢复登录状态（不显示弹窗）
      this.$store.commit('SET_LOGIN', {
        user: JSON.parse(localStorage.getItem('user')),
        token: token
      })

      // 可选：验证Token是否有效
      // this.$store.dispatch('validateToken')
    }
  }
  // computed: {
  //   ...mapState(['showDialog']),
  // },
  // methods: {
  //   ...mapMutations(['SET_SHOW_LOGIN_DIALOG']),
  // },
  // watch: {
  //   showDialog(newVal) {
  //     if (newVal) {
  //       this.$refs.loginDialog.openDialog();
  //     }
  //   },
  // },
}
</script>

<style>
#app {
  font-family: PingFangSC-Regular, Microsoft YaHei, Heiti, Arial, Helvetica, "sans-serif" !important;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue